import { useEffect, useRef, useState } from 'react';
import { claimVideo, releaseVideo } from '@/lib/video-playback';
import { mayAutoplayVideo } from '@/lib/tour-video';

export function ManagedVideo({ src, poster, auto = false, controls = false, muted = true, onProgress, onEnded }: {
  src: string | null; poster: string | null; auto?: boolean; controls?: boolean; muted?: boolean;
  onProgress?: (value: number) => void; onEnded?: () => void;
}) {
  const ref = useRef<HTMLVideoElement>(null);
  const [ready,setReady] = useState(false);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    let inside = false;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = (navigator as Navigator & { connection?: { saveData?: boolean; addEventListener?: (name:string,cb:()=>void)=>void; removeEventListener?: (name:string,cb:()=>void)=>void } }).connection;
    const update = () => {
      const saved = !!connection?.saveData;
      if (inside && !saved && (!auto || !reduce.matches)) setReady(true);
      if (auto && mayAutoplayVideo(saved,reduce.matches,inside,!document.hidden)) { claimVideo(el); void el.play().catch(()=>{}); }
      else if (!inside || document.hidden || saved || (auto && reduce.matches)) el.pause();
    };
    const observer = new IntersectionObserver(([entry]) => { inside = entry.isIntersecting; update(); },{threshold:0.25});
    observer.observe(el); el.addEventListener('loadeddata',update);
    document.addEventListener('visibilitychange',update); reduce.addEventListener('change',update); connection?.addEventListener?.('change',update);
    return () => { observer.disconnect(); el.pause(); releaseVideo(el); el.removeEventListener('loadeddata',update); document.removeEventListener('visibilitychange',update); reduce.removeEventListener('change',update); connection?.removeEventListener?.('change',update); };
  },[auto,src]);
  return <video ref={ref} src={ready && src ? src : undefined} poster={poster ?? undefined} preload="metadata" muted={muted} playsInline loop={auto && !onEnded} controls={controls} className="h-full w-full object-cover" onPlay={e=>claimVideo(e.currentTarget)} onTimeUpdate={e=>{const v=e.currentTarget;if(v.duration)onProgress?.(v.currentTime/v.duration);}} onEnded={onEnded} />;
}